export const openSigningSupport = 'Merchant/OpenSigningSupportRequest';
export const getDocumentsToSign = 'Merchant/GetDocumentsToSignPreview';
export const getDocumentPreview = 'Merchant/GetDocumentPreview';
export const proceedNotItalianSigning = 'Merchant/ProceedNotItalianSigning';
